import { NgModule } from '@angular/core';
import { BrlCurrencyPipe } from './brl-currency.pipe';

@NgModule({
  declarations: [BrlCurrencyPipe],
  exports: [BrlCurrencyPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts